theme.headerMainMenuModule = (function () {
  function mainMenu() {
    document.querySelectorAll(".header__menu_li.menu__item_has_children").forEach(item => {
      let details = item.querySelector("details");
      if (details && !item.hasAttribute("data-hover-fixed")) {
        item.setAttribute("data-hover-fixed", "true");
        
        let summary = item.querySelector("summary");
        
        item.addEventListener("mouseover", () => details.setAttribute("open", ""));
        item.addEventListener("mouseleave", () => details.removeAttribute("open"));
        
        if (summary) {
          summary.addEventListener("click", (e) => {
            e.stopPropagation();
            let url = summary.getAttribute("data-href");
            if (url && details.hasAttribute("open")) {
              window.location.href = window.location.origin + url;
            }
          });
        }
      }
    });
  }
  document.addEventListener("DOMContentLoaded", mainMenu);
  mainMenu();
  return {
    mainMenu: mainMenu
  }
})();